<template>
  <div>
    finalizing auth....
  </div>
</template>

<script>
export default {
  data () {
    return {
      authCode: '',
      authState: ''
    }
  },
  beforeMount () {
    this.authCode = this.$route.query.code
    this.authState = this.$route.query.state
    this.$store.dispatch('handleAuthHavenLock', { 'authCode': this.authCode, 'authState': this.authState })
  }
}
</script>

<style scoped>

</style>
